import Util from '../Util';

class User {
  constructor(obj = {}) {
    this.email = obj.email;
    this.firstName = obj.firstName;
    this.lastName = obj.lastName;
    this.role = obj.role;
    this.shouldChangePassword = obj.shouldChangePassword;
    this.isDisabled = obj.isDisabled;
    this.password = obj.password;
    this.lastUpdated = obj.lastUpdated;
    this.dateCreated = obj.dateCreated;
    this.lastUpdatedBy = obj.lastUpdatedBy;

    // extra
    this.roleDesc = toRoleDesc(this.role);
    this.dateCreatedDateTime = Util.localDateTimeString(obj.dateCreated);
    this.dateCreatedXAgo = 'unknown';
    if (obj.dateCreated) {
      this.dateCreatedXAgo = Util.xUnitsOfTimeAgo(obj.dateCreated);
    }
    this.lastUpdatedDateTime = Util.localDateTimeString(obj.lastUpdated);
    this.lastUpdatedXAgo = 'unknown';
    if (obj.lastUpdated) {
      this.lastUpdatedXAgo = Util.xUnitsOfTimeAgo(obj.lastUpdated);
    }
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        // don't include these keys
        case 'dateCreatedXAgo':
        case 'dateCreatedDateTime':
        case 'lastUpdatedXAgo':
        case 'lastUpdatedDateTime':
          break;
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }

  isRole(role) {
    if (!role) return false;
    return new RegExp('^' + role + '$', 'i').test(this.role);
  }

  // Also see server/routes.js for role restrictions on proxy urls

  isCommissionRole() {
    return this.isRole('commission');
  }

  isFrontLevelSupportRole() {
    return this.isRole('front-level-support');
  }

  isBasicSupportRole() {
    return this.isRole('basic-support');
  }

  isImplementationRole() {
    return this.isRole('implementation');
  }

  isSuperRole() {
    return this.isRole('super');
  }
}

function toRoleDesc(role) {
  if (role) {
    let words = role.replace(/-/g, ' ').split(/\s/);
    let roleDesc = '';
    for (let word of words) {
      roleDesc += capitalizeFirstLetter(word) + ' ';
    }
    return roleDesc;
  }
  return role;
}

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default User;



// WEBPACK FOOTER //
// ./src/model/User.js